<template>
  <div>
    <div class="header mb-10">
      <el-button
        @click="handleNew"
        type="primary"
        icon="el-icon-plus"
        size="small"
        v-permission="Auth.productNew"
        >新增设备</el-button
      >
      <file-button
        style="float: right"
        class="mobile-hide"
        obj="device"
        :filter="filter"
        @importCallback="requestItemList"
        v-permission="Auth.productIE"
      ></file-button>
    </div>
    <el-table
      v-loading="loading"
      :data="lists"
      stripe
      ref="table"
      header-row-class-name="q-products-header"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="44"> </el-table-column>
      <el-table-column prop="name" label="名称/件号">
        <template slot-scope="scope">
          <div>{{ scope.row.name }}</div>
          <div>{{ scope.row.part_number }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="item_category.name" label="供应商/分类">
        <template slot-scope="scope">
          <div v-if="userInfo.dealer_id > 0">
            {{
              scope.row.dealer_id == 0 ? '阿特拉斯' : scope.row.supplier.name
            }}
          </div>
          <div>
            {{ scope.row.item_category.whole_name.replace(/,/g, ' - ') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="machine_type"
        label="机型"
        align="center"
        width="120"
      ></el-table-column>
      <el-table-column label="成本价" align="center" width="120">
        <template slot-scope="scope">{{
          scope.row.cost_price.price.toFixed(2)
        }}</template>
      </el-table-column>
      <el-table-column label="定价" align="center" width="120">
        <template slot-scope="scope">{{ scope.row.price.toFixed(2) }}</template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="描述"
        align="center"
      ></el-table-column>
      <el-table-column align="right" label="操作" width="150px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            class="mr-10"
            @click="handleEdit(scope.$index, scope.row)"
            v-if="scope.row.dealer_id == userInfo.dealer_id"
            v-permission="Auth.productEdit"
            >编辑</el-button
          >
          <el-popconfirm
            v-permission="Auth.productDelete"
            title="确认删除吗？"
            @confirm="handleDelete(scope.$index, scope.row)"
            v-if="scope.row.dealer_id == userInfo.dealer_id"
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >删除</el-button
            >
          </el-popconfirm>
          <el-button
            size="mini"
            type="primary"
            plain
            @click="editItemCostPrice(scope.row, scope.$index)"
            v-if="scope.row.dealer_id != userInfo.dealer_id"
            v-permission="Auth.productEdit"
            >编辑成本价</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="flex-row-between mt-20">
      <div>
        <el-checkbox
          class="mr-10"
          style="margin-left: 14px"
          @change="toggleAllSelection"
          v-model="selectedAll"
          >{{ selectedAll ? '取消全选' : '全部选择' }}</el-checkbox
        >
        <el-button size="mini" type="danger" @click="batchDelete"
          >批量删除</el-button
        >
      </div>
      <div class="flex-row-base">
        <el-select
          v-model="filter.size"
          placeholder="请选择"
          size="mini"
          style="width: 100px; margin-right: 10px"
        >
          <el-option
            v-for="item in sizeOptions"
            :key="item"
            :label="'每页' + item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-pagination
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          @current-change="handlePageChange"
          :page-size="filter.size"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <device-former
      :model="model"
      :show.sync="dialogVisible"
      :showSupplier.sync="userInfo.dealer_id > 0"
      @created="createdModel"
      @updated="updatedModel"
    ></device-former>

    <item-cost-price-former
      :model="model"
      :show.sync="costPriceVisible"
      @updated="updatedModel"
    ></item-cost-price-former>
  </div>
</template>

<script>
import store from '@/store/store'
import deviceFormer from '@/components/device'
import itemCostPriceFormer from '@/components/item_cost_price'
import { itemList, deleteItem, itemBatchDelete } from '@/service/getData'
import { clone } from '@/util'

export default {
  components: {
    deviceFormer,
    itemCostPriceFormer,
  },
  props: {
    filter: Object,
  },
  data() {
    return {
      loading: true,
      total: 0,
      lists: [],
      userInfo: {},
      sizeOptions: [20, 50, 100],
      model: { cost_price: { price: 0 } },
      editIndex: 0,
      dialogVisible: false,
      costPriceVisible: false,
      tableSelection: [],
      selectedAll: false,
    }
  },
  watch: {
    filter: {
      handler(newVal) {
        this.requestItemList()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.userInfo = store.state.userInfo
  },
  methods: {
    async requestItemList() {
      let data = clone(this.filter)
      data.page = data.page - 1
      this.loading = true
      let res = await itemList(data)
      if (res.code == 0) {
        this.lists = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    handlePageChange(e) {
      this.filter.page = e
      this.requestItemList()
    },
    createdModel(data) {
      this.lists.unshift(data)
    },
    updatedModel(data) {
      this.lists[this.editIndex] = data
    },
    handleNew() {
      this.model = {
        name: '',
        category: 2,
        machine_type: '',
        supplier_id: '',
        item_category_id: '',
        params: '',
        price: 0,
        cost_price: {
          price: 0,
        },
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      this.dialogVisible = true
      this.editIndex = index
      this.$nextTick(() => {
        this.model = clone(item)
        this.model.item_category_id =
          this.model.item_category_id == 0 ? '' : this.model.item_category_id
        this.model.supplier_id =
          this.model.supplier_id == 0 ? '' : this.model.supplier_id
      })
    },
    editItemCostPrice(item, index) {
      this.editIndex = index
      this.costPriceVisible = true
      this.$nextTick(() => {
        this.model = {
          id: item.id,
          name: item.name,
          cost_price: clone(item.cost_price),
        }
      })
    },
    async handleDelete(index, item) {
      let res = await deleteItem(item.id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
      }
    },
    batchDelete() {
      if (this.tableSelection.length == 0) {
        return
      }
      let that = this
      this.$confirm(
        '是否确认批量删除所选' + this.tableSelection.length + '项',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        let ids = that.tableSelection.map((i) => {
          return i.id
        })
        itemBatchDelete({ ids: ids }).then((res) => {
          if (res.code == 0) {
            this.tableSelection = []
            this.selectedAll = false
            that.$message.success('删除成功')
            // that.filter.page -= 1
            // that.filter.page = Math.min(that.filter.page, 0)
            that.requestItemList()
          }
        })
      })
    },
    toggleAllSelection() {
      this.$refs.table.toggleAllSelection(this.selectedAll)
    },
    handleSelectionChange(val) {
      this.tableSelection = val
      this.selectedAll = this.lists.length == val.length
    },
  },
}
</script>